module.exports = {
	"config": {
		"linkPrefix": "",
		"name": "wyvern-ethereum",
		"license": "MIT",
		"version": "1.0.0",
		"description": "Wyvern Ethereum Contracts",
		"homepage": "https://github.com/ProjectWyvern/wyvern-ethereum#readme",
		"author": "Project Wyvern Developers",
		"buildTime": "2018-03-04T03:35:33.490Z",
		"target": "doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"out": "docs",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ArrayUtils.json",
				"ext": "json",
				"name": "ArrayUtils",
				"extname": ".json",
				"basename": "ArrayUtils.json",
				"dirname": "docs",
				"stem": "ArrayUtils",
				"path": "docs/ArrayUtils.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/ArrayUtils.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ArrayUtils.json",
			"path": "/docs/ArrayUtils/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "AuthenticatedProxy.json",
				"ext": "json",
				"name": "AuthenticatedProxy",
				"extname": ".json",
				"basename": "AuthenticatedProxy.json",
				"dirname": "docs",
				"stem": "AuthenticatedProxy",
				"path": "docs/AuthenticatedProxy.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/AuthenticatedProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/AuthenticatedProxy.json",
			"path": "/docs/AuthenticatedProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BasicToken.json",
				"ext": "json",
				"name": "BasicToken",
				"extname": ".json",
				"basename": "BasicToken.json",
				"dirname": "docs",
				"stem": "BasicToken",
				"path": "docs/BasicToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/BasicToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BasicToken.json",
			"path": "/docs/BasicToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BurnableToken.json",
				"ext": "json",
				"name": "BurnableToken",
				"extname": ".json",
				"basename": "BurnableToken.json",
				"dirname": "docs",
				"stem": "BurnableToken",
				"path": "docs/BurnableToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/BurnableToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BurnableToken.json",
			"path": "/docs/BurnableToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DelayedReleaseToken.json",
				"ext": "json",
				"name": "DelayedReleaseToken",
				"extname": ".json",
				"basename": "DelayedReleaseToken.json",
				"dirname": "docs",
				"stem": "DelayedReleaseToken",
				"path": "docs/DelayedReleaseToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/DelayedReleaseToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DelayedReleaseToken.json",
			"path": "/docs/DelayedReleaseToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DelegatedShareholderAssociation.json",
				"ext": "json",
				"name": "DelegatedShareholderAssociation",
				"extname": ".json",
				"basename": "DelegatedShareholderAssociation.json",
				"dirname": "docs",
				"stem": "DelegatedShareholderAssociation",
				"path": "docs/DelegatedShareholderAssociation.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/DelegatedShareholderAssociation.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DelegatedShareholderAssociation.json",
			"path": "/docs/DelegatedShareholderAssociation/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DelegateProxy.json",
				"ext": "json",
				"name": "DelegateProxy",
				"extname": ".json",
				"basename": "DelegateProxy.json",
				"dirname": "docs",
				"stem": "DelegateProxy",
				"path": "docs/DelegateProxy.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/DelegateProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DelegateProxy.json",
			"path": "/docs/DelegateProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Exchange.json",
				"ext": "json",
				"name": "Exchange",
				"extname": ".json",
				"basename": "Exchange.json",
				"dirname": "docs",
				"stem": "Exchange",
				"path": "docs/Exchange.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/Exchange.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Exchange.json",
			"path": "/docs/Exchange/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ExchangeCore.json",
				"ext": "json",
				"name": "ExchangeCore",
				"extname": ".json",
				"basename": "ExchangeCore.json",
				"dirname": "docs",
				"stem": "ExchangeCore",
				"path": "docs/ExchangeCore.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/ExchangeCore.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ExchangeCore.json",
			"path": "/docs/ExchangeCore/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "MerkleProof.json",
				"ext": "json",
				"name": "MerkleProof",
				"extname": ".json",
				"basename": "MerkleProof.json",
				"dirname": "docs",
				"stem": "MerkleProof",
				"path": "docs/MerkleProof.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/MerkleProof.json",
				"isAbsolute": false
			},
			"requirePath": "docs/MerkleProof.json",
			"path": "/docs/MerkleProof/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Ownable.json",
				"ext": "json",
				"name": "Ownable",
				"extname": ".json",
				"basename": "Ownable.json",
				"dirname": "docs",
				"stem": "Ownable",
				"path": "docs/Ownable.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/Ownable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Ownable.json",
			"path": "/docs/Ownable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ProxyRegistry.json",
				"ext": "json",
				"name": "ProxyRegistry",
				"extname": ".json",
				"basename": "ProxyRegistry.json",
				"dirname": "docs",
				"stem": "ProxyRegistry",
				"path": "docs/ProxyRegistry.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/ProxyRegistry.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ProxyRegistry.json",
			"path": "/docs/ProxyRegistry/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ReentrancyGuarded.json",
				"ext": "json",
				"name": "ReentrancyGuarded",
				"extname": ".json",
				"basename": "ReentrancyGuarded.json",
				"dirname": "docs",
				"stem": "ReentrancyGuarded",
				"path": "docs/ReentrancyGuarded.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/ReentrancyGuarded.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ReentrancyGuarded.json",
			"path": "/docs/ReentrancyGuarded/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMath.json",
				"ext": "json",
				"name": "SafeMath",
				"extname": ".json",
				"basename": "SafeMath.json",
				"dirname": "docs",
				"stem": "SafeMath",
				"path": "docs/SafeMath.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/SafeMath.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMath.json",
			"path": "/docs/SafeMath/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SaleKindInterface.json",
				"ext": "json",
				"name": "SaleKindInterface",
				"extname": ".json",
				"basename": "SaleKindInterface.json",
				"dirname": "docs",
				"stem": "SaleKindInterface",
				"path": "docs/SaleKindInterface.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/SaleKindInterface.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SaleKindInterface.json",
			"path": "/docs/SaleKindInterface/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StandardToken.json",
				"ext": "json",
				"name": "StandardToken",
				"extname": ".json",
				"basename": "StandardToken.json",
				"dirname": "docs",
				"stem": "StandardToken",
				"path": "docs/StandardToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/StandardToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StandardToken.json",
			"path": "/docs/StandardToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestDAO.json",
				"ext": "json",
				"name": "TestDAO",
				"extname": ".json",
				"basename": "TestDAO.json",
				"dirname": "docs",
				"stem": "TestDAO",
				"path": "docs/TestDAO.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TestDAO.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestDAO.json",
			"path": "/docs/TestDAO/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestStatic.json",
				"ext": "json",
				"name": "TestStatic",
				"extname": ".json",
				"basename": "TestStatic.json",
				"dirname": "docs",
				"stem": "TestStatic",
				"path": "docs/TestStatic.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TestStatic.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestStatic.json",
			"path": "/docs/TestStatic/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TestToken.json",
				"ext": "json",
				"name": "TestToken",
				"extname": ".json",
				"basename": "TestToken.json",
				"dirname": "docs",
				"stem": "TestToken",
				"path": "docs/TestToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TestToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TestToken.json",
			"path": "/docs/TestToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TokenLocker.json",
				"ext": "json",
				"name": "TokenLocker",
				"extname": ".json",
				"basename": "TokenLocker.json",
				"dirname": "docs",
				"stem": "TokenLocker",
				"path": "docs/TokenLocker.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TokenLocker.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TokenLocker.json",
			"path": "/docs/TokenLocker/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TokenRecipient.json",
				"ext": "json",
				"name": "TokenRecipient",
				"extname": ".json",
				"basename": "TokenRecipient.json",
				"dirname": "docs",
				"stem": "TokenRecipient",
				"path": "docs/TokenRecipient.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TokenRecipient.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TokenRecipient.json",
			"path": "/docs/TokenRecipient/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "TokenTransferProxy.json",
				"ext": "json",
				"name": "TokenTransferProxy",
				"extname": ".json",
				"basename": "TokenTransferProxy.json",
				"dirname": "docs",
				"stem": "TokenTransferProxy",
				"path": "docs/TokenTransferProxy.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/TokenTransferProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/TokenTransferProxy.json",
			"path": "/docs/TokenTransferProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "UTXORedeemableToken.json",
				"ext": "json",
				"name": "UTXORedeemableToken",
				"extname": ".json",
				"basename": "UTXORedeemableToken.json",
				"dirname": "docs",
				"stem": "UTXORedeemableToken",
				"path": "docs/UTXORedeemableToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/UTXORedeemableToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/UTXORedeemableToken.json",
			"path": "/docs/UTXORedeemableToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernAtomicizer.json",
				"ext": "json",
				"name": "WyvernAtomicizer",
				"extname": ".json",
				"basename": "WyvernAtomicizer.json",
				"dirname": "docs",
				"stem": "WyvernAtomicizer",
				"path": "docs/WyvernAtomicizer.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernAtomicizer.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernAtomicizer.json",
			"path": "/docs/WyvernAtomicizer/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernDAO.json",
				"ext": "json",
				"name": "WyvernDAO",
				"extname": ".json",
				"basename": "WyvernDAO.json",
				"dirname": "docs",
				"stem": "WyvernDAO",
				"path": "docs/WyvernDAO.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernDAO.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernDAO.json",
			"path": "/docs/WyvernDAO/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernDAOProxy.json",
				"ext": "json",
				"name": "WyvernDAOProxy",
				"extname": ".json",
				"basename": "WyvernDAOProxy.json",
				"dirname": "docs",
				"stem": "WyvernDAOProxy",
				"path": "docs/WyvernDAOProxy.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernDAOProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernDAOProxy.json",
			"path": "/docs/WyvernDAOProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernExchange.json",
				"ext": "json",
				"name": "WyvernExchange",
				"extname": ".json",
				"basename": "WyvernExchange.json",
				"dirname": "docs",
				"stem": "WyvernExchange",
				"path": "docs/WyvernExchange.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernExchange.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernExchange.json",
			"path": "/docs/WyvernExchange/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernProxyRegistry.json",
				"ext": "json",
				"name": "WyvernProxyRegistry",
				"extname": ".json",
				"basename": "WyvernProxyRegistry.json",
				"dirname": "docs",
				"stem": "WyvernProxyRegistry",
				"path": "docs/WyvernProxyRegistry.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernProxyRegistry.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernProxyRegistry.json",
			"path": "/docs/WyvernProxyRegistry/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernToken.json",
				"ext": "json",
				"name": "WyvernToken",
				"extname": ".json",
				"basename": "WyvernToken.json",
				"dirname": "docs",
				"stem": "WyvernToken",
				"path": "docs/WyvernToken.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernToken.json",
			"path": "/docs/WyvernToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "WyvernTokenTransferProxy.json",
				"ext": "json",
				"name": "WyvernTokenTransferProxy",
				"extname": ".json",
				"basename": "WyvernTokenTransferProxy.json",
				"dirname": "docs",
				"stem": "WyvernTokenTransferProxy",
				"path": "docs/WyvernTokenTransferProxy.json",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/docs/WyvernTokenTransferProxy.json",
				"isAbsolute": false
			},
			"requirePath": "docs/WyvernTokenTransferProxy.json",
			"path": "/docs/WyvernTokenTransferProxy/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/home/cwgoes/working/crypto/wyvern/wyvern-ethereum/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0